import { Job, User } from '@core/generated/gql-types';

interface WorkerSearchbarListProps {
  searchQuery: string;
  job: Job;
  isLoading: boolean;
  filteredWorkers: User[];
  setSelectedWorker: (worker: User) => void;
}

const WorkerSearchbarList = ({
  searchQuery,
  job,
  isLoading,
  filteredWorkers,
  setSelectedWorker,
}: WorkerSearchbarListProps) => {
  if (isLoading) {
    return <div className="text-sm text-gray-600">Loading workers...</div>;
  }

  if (filteredWorkers.length === 0) {
    if (searchQuery) {
      return (
        <div className="text-sm text-gray-600">
          No workers found matching your search
        </div>
      );
    }

    return (
      <div className="text-sm text-gray-600">
        No workers available for this classification
      </div>
    );
  }

  return (
    <div>
      {filteredWorkers.map((worker) => {
        return (
          <div
            key={worker.id}
            className={`flex items-center justify-between rounded-md border border-gray-200 bg-white p-2`}
          >
            <div className="flex items-center gap-2">
              <div className="flex h-10 w-10 items-center overflow-hidden rounded-full bg-gray-100">
                {worker?.profilePictureUrl ? (
                  <img
                    src={worker.profilePictureUrl}
                    alt={`${worker.firstName} ${worker.lastName}`}
                    className="h-10 w-10 object-contain"
                  />
                ) : (
                  <div className="h-10 w-10 rounded-full bg-gray-200" />
                )}
              </div>
              <div className="flex flex-col">
                <p className="text-sm font-medium text-gray-900">
                  {`${worker?.firstName || ''} ${worker?.lastName || ''}`.trim()}
                </p>
                <p className="text-sm text-gray-400">
                  {job?.classification?.name || 'General Labourer'}
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={() => setSelectedWorker(worker)}
              className={`rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-500`}
            >
              Select
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default WorkerSearchbarList;
